import type { CrowdexUIMessage } from '@crowdex/agent-contracts';
import type { PersonaReplyRequest, PersonaReplyResponse } from '@crowdex/agent-contracts/api';
import { apiFetch } from '@crowdex/host-kit/renderer/http';
import { decodeAgentMentionLabel } from '@crowdex/ui/lib/inline-reference';

/** A persona's one reply in a conversation: the user's message, then its reply, as stored. */
export async function requestPersonaReply(
  request: PersonaReplyRequest,
): Promise<CrowdexUIMessage[]> {
  const { messages } = await apiFetch<PersonaReplyResponse>(
    `/api/conversations/${encodeURIComponent(request.conversationId)}/persona-reply`,
    {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(request),
    },
  );
  return messages as CrowdexUIMessage[];
}

// The composer's inline reference to a saved agent: `@[label](persona:id)`.
const PERSONA_MENTION = /@\[((?:\\.|[^\]\\])+)]\(persona:([^)]+)\)/;

/** The first persona a message names, as the composer writes it; null when it names none. */
export function personaMentionOf(text: string): { id: string; label: string } | null {
  const match = PERSONA_MENTION.exec(text);
  if (match?.[1] === undefined || match[2] === undefined) return null;
  return { id: match[2], label: decodeAgentMentionLabel(match[1]) };
}
